import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

interface FadeGradientProps {
  isVisible?: boolean;
}

export const FadeGradient = ({ isVisible = true }: FadeGradientProps) => {
  const { isCircleV4 } = useCircleV4();

  return (
    <div
      aria-hidden
      className={classNames(
        "pointer-events-none absolute inset-x-0 top-[-48px] h-[48px] bg-gradient-to-b from-transparent transition-opacity duration-200",
        {
          "to-[var(--color-background-primary)] dark:to-[var(--color-background-secondary)]":
            isCircleV4,
          "to-[var(--color-background-primary)]": !isCircleV4,
          "opacity-0": !isVisible,
        },
      )}
    />
  );
};
